import { BaseResource } from 'utils/ApiUtils';

export default class CustomField extends BaseResource {
  constructor(args, attr = CustomField.attributes) {
    super(args, attr)
  }

  static columns = [
    { title: "Name", field: "Description_CustomFieldName", type: "string", sorting: false, filter: false },
    { title: "CustomFieldId", field: "CustomFieldId", hidden: true, type: "string" },
    { title: "customFieldNameId", field: "CustomFieldNameId_CustomFieldName", hidden: true, type: "string" },
    { title: "Value", field: "FieldValue", type: "string", sorting: false, filter: false },
 
  ]

  static attributes = CustomField.columns.map(r => r.field);

  static expand = {
    "ProjectCustomField": { 
      "expand": [{ "CustomFieldName": { "select": ["Description", "CustomFieldNameId"] } }],
      "select": ["FieldValue", "CustomFieldId"]
    }
  }
}

